module.exports = __webpack_public_path__ + "static/rfa-adi@2x-1-300x177-ba9e2aabea57efefe6e4373aebb6ff89.png";